import gameIcon from 'assets/images/sprite/game.svg'
import emojiHappyIcon from 'assets/images/sprite/emoji-happy.svg'
import musicIcon from 'assets/images/sprite/music.svg'
import favoriteChartIcon from 'assets/images/sprite/favorite-chart.svg'
import rankingIcon from 'assets/images/sprite/ranking.svg'
import flowerIcon from 'assets/images/sprite/flower.svg'
import { PurchaseProduct } from 'modules/purchase/constants'

export const PERSONAL_PLAN_INCLUDES_ITEMS = [
  { id: '1', value: 'purchase2.helpsYouRelax', icon: gameIcon },
  { id: '2', value: 'purchase2.moodTracker', icon: emojiHappyIcon },
  { id: '3', value: 'purchase2.calmingSounds', icon: musicIcon },
  { id: '4', value: 'purchase2.personalityTests', icon: favoriteChartIcon },
  { id: '5', value: 'purchase2.dailyMotivation', icon: rankingIcon },
  { id: '6', value: 'purchase2.breathingTechniques', icon: flowerIcon },
]

export const USER_BENEFITS = [
  { id: '1', value: 'purchase2.benefits.improveMentalHealth' },
  { id: '2', value: 'purchase2.benefits.exploreGames' },
  { id: '3', value: 'purchase2.benefits.watchScenes' },
  { id: '4', value: 'purchase2.benefits.achieveRelaxation' },
  { id: '5', value: 'purchase2.benefits.trackMoods' },
  { id: '6', value: 'purchase2.benefits.receiveInsights' },
]

export const PRICE_DESCRIPTION_KEYS = {
  [PurchaseProduct.ONE_MONTH]: 'purchase2.subscription.monthlyDisclaimer',
  [PurchaseProduct.THREE_MONTHS]: 'purchase2.subscription.quarterlyDisclaimer',
  [PurchaseProduct.SIX_MONTHS]: 'purchase2.subscription.semiannuallyDisclaimer',
}
